module.exports = __webpack_public_path__ + "img/stop_btn.7b62c21a.png";